(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-register-form"] && !Shopify.designMode) return;
  try {
    
  // ── UTM Capture: Runs immediately on ANY page load ────────────────────────
  // Stores UTM params in sessionStorage so they persist across page navigation.
  // If user arrives via ?utm_source=boutiques+singapore+2026 then navigates
  // to /register, the UTM is still available.
  (function captureUTMs() {
    try {
      var urlParams = new URLSearchParams(window.location.search);
      var utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
      var captured = {};
      var hasUTM = false;
      for (var i = 0; i < utmKeys.length; i++) {
        var v = urlParams.get(utmKeys[i]);
        if (v) {
          captured[utmKeys[i]] = v;
          hasUTM = true;
        }
      }
      if (hasUTM) {
        // Overwrite with fresher UTMs from current URL
        sessionStorage.setItem(
          'ariseo_utms',
          JSON.stringify({
            data: captured,
            ts: Date.now(),
          })
        );
      }
    } catch (e) {}
  })();
  // ────────────────────────────────────────────────────────────────────────────

  (function () {
    // ─── CONFIG — Đăng ký qua App Proxy của app "Ariseo API" ─────────────────
    // Đường tương đối trên chính domain store: Shopify nhận, ký request (shop,
    // timestamp, signature) rồi chuyển tiếp sang service ariseo-api (Railway).
    // Không CORS, không lộ URL backend, request không giả được. Cùng một dòng này
    // dùng cho mọi store đã cài app (SG, KR…) — service chọn store theo `shop` đã ký.
    // Trước đây: '/apps/rewards/proxy/register' (app rewards, đã gỡ 2026-09-10).
    // Đây là request chính: có await, kết quả hiển thị cho khách.
    var SIGNUP_API_URL = '/apps/signup/register';
    // ────────────────────────────────────────────────────────────────────────────

    // ─── CONFIG — Sync song song sang GoHighLevel (Railway) ──────────────────
    // Fire-and-forget: không chặn / không ảnh hưởng flow đăng ký chính ở trên.
    var GHL_SYNC_URL = 'https://ariseo-to-ghl-production.up.railway.app/ghl/signup';
    var GHL_SYNC_SECRET = '8abb7fb05e108628d26e1b8432dd9d3b92efab4de1c571f2';
    // ────────────────────────────────────────────────────────────────────────────

    var form = document.getElementById('CustomRegisterForm');
    var alert = document.getElementById('RegisterAlert');
    var btn = document.getElementById('RegisterSubmitBtn');
    var btnText = btn.querySelector('.btn-text');
    var btnLoad = btn.querySelector('.btn-loading');
    var heading = document.querySelector('.custom-register-heading');
    var subheading = document.querySelector('.custom-register-subheading');

    if (!form) return;

    // Custom Dropdown logic
    var countrySelect = document.getElementById('RegisterForm-CountryCode');
    var flagImg = document.getElementById('CurrentFlag');
    var wrapper = document.getElementById('CountrySelectWrapper');

    if (countrySelect && flagImg && wrapper) {
      var dropdownList = document.createElement('div');
      dropdownList.className = 'country-dropdown-list';

      Array.from(countrySelect.options).forEach(function (opt) {
        var originalText = opt.text;
        var match = originalText.match(/\b([A-Z]{2})\b/);
        var iso = match ? match[1].toLowerCase() : 'sg';
        var cleanText = originalText.replace(/[^\x00-\x7F]/g, '').trim();

        var optDiv = document.createElement('div');
        optDiv.className = 'country-dropdown-option';
        if (opt.selected) optDiv.classList.add('is-selected');

        optDiv.innerHTML =
          '<img src="https://flagcdn.com/w20/' +
          iso +
          '.png" srcset="https://flagcdn.com/w40/' +
          iso +
          '.png 2x" alt="' +
          iso +
          '" class="flag-img-small" loading="lazy"><span>' +
          cleanText +
          '</span>';

        optDiv.addEventListener('click', function (e) {
          e.stopPropagation();
          countrySelect.value = opt.value;
          flagImg.src = 'https://flagcdn.com/w40/' + iso + '.png';
          flagImg.alt = iso.toUpperCase();
          wrapper.classList.remove('is-open');

          dropdownList.querySelectorAll('.country-dropdown-option').forEach(function (el) {
            el.classList.remove('is-selected');
          });
          optDiv.classList.add('is-selected');
        });

        dropdownList.appendChild(optDiv);
      });

      wrapper.appendChild(dropdownList);

      wrapper.addEventListener('click', function (e) {
        e.stopPropagation();
        wrapper.classList.toggle('is-open');
        if (wrapper.classList.contains('is-open')) {
          var selected = dropdownList.querySelector('.is-selected');
          if (selected) {
            setTimeout(function () {
              selected.scrollIntoView({ block: 'nearest' });
            }, 10);
          }
        }
      });

      document.addEventListener('click', function () {
        wrapper.classList.remove('is-open');
      });
    }

    function showAlert(type, message) {
      alert.className = 'register-alert register-alert--' + type;
      alert.innerHTML = message;
      alert.style.display = 'block';
      alert.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function setLoading(isLoading) {
      btn.disabled = isLoading;
      btnText.style.display = isLoading ? 'none' : 'inline';
      btnLoad.style.display = isLoading ? 'inline' : 'none';
    }

    // Build note string from Birthday
    function buildNote() {
      var parts = [];

      var birthday = document.getElementById('RegisterForm-Birthday');
      if (birthday && birthday.value) {
        parts.push('Birthday: ' + birthday.value);
      }

      return parts.join(' | ');
    }

    // Client-side validation
    function validate() {
      var email = document.getElementById('RegisterForm-email');
      var firstName = document.getElementById('RegisterForm-FirstName');
      var lastName = document.getElementById('RegisterForm-LastName');
      var phone = document.getElementById('RegisterForm-Phone');
      var birthday = document.getElementById('RegisterForm-Birthday');

      if (!firstName.value.trim()) {
        showAlert('error', '⚠️ Please enter your First Name.');
        firstName.focus();
        return false;
      }
      if (!lastName.value.trim()) {
        showAlert('error', '⚠️ Please enter your Last Name.');
        lastName.focus();
        return false;
      }
      if (!phone.value.trim()) {
        showAlert('error', '⚠️ Please enter your Phone Number.');
        phone.focus();
        return false;
      }
      if (!birthday || !birthday.value) {
        showAlert('error', '⚠️ Please enter your Date of Birth.');
        if (birthday) birthday.focus();
        return false;
      }
      if (!email.value.trim() || !email.value.includes('@')) {
        showAlert('error', '⚠️ Invalid email address.');
        email.focus();
        return false;
      }

      var required = form.querySelectorAll('input[type="checkbox"][required]');
      for (var i = 0; i < required.length; i++) {
        if (!required[i].checked) {
          showAlert('error', '⚠️ Please agree to the terms to continue.');
          required[i].focus();
          return false;
        }
      }
      return true;
    }

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      alert.style.display = 'none';

      if (!validate()) return;

      setLoading(true);

      var policy1 = document.getElementById('Register-Policy1');
      var policy2 = document.getElementById('Register-Policy2');

      // Priority 1: current page URL (most fresh)
      // Priority 2: sessionStorage (from initial landing page with UTM)
      function getUTMParams() {
        var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
        var utms = {};

        // Check current URL first
        var urlParams = new URLSearchParams(window.location.search);
        var hasFromUrl = false;
        for (var i = 0; i < keys.length; i++) {
          var val = urlParams.get(keys[i]);
          if (val) {
            utms[keys[i]] = val;
            hasFromUrl = true;
          }
        }
        if (hasFromUrl) return utms;

        // Fallback: sessionStorage (UTMs from initial landing page)
        try {
          var stored = sessionStorage.getItem('ariseo_utms');
          if (stored) {
            var parsed = JSON.parse(stored);
            // Expire after 30 days (ms)
            var TTL_30_DAYS = 30 * 24 * 60 * 60 * 1000;
            if (parsed && parsed.data && parsed.ts && Date.now() - parsed.ts < TTL_30_DAYS) {
              return parsed.data;
            }
          }
        } catch (e) {}

        return utms;
      }

      var payload = {
        email: document.getElementById('RegisterForm-email').value.trim(),
        first_name: document.getElementById('RegisterForm-FirstName').value.trim(),
        last_name: document.getElementById('RegisterForm-LastName').value.trim(),
        phone:
          document.getElementById('RegisterForm-CountryCode').value +
          document.getElementById('RegisterForm-Phone').value.trim(),
        birthday: document.getElementById('RegisterForm-Birthday').value.trim(),
        note: buildNote(),
        marketing_email: policy2 ? policy2.checked : false,
        agree_terms: policy1 ? policy1.checked : false,
        agree_policy2: policy2 ? policy2.checked : false,
        utms: getUTMParams(),
      };

      // Bắn song song sang GoHighLevel — không await, không chặn flow đăng ký
      // chính, lỗi bị nuốt im lặng nếu sync thất bại.
      fetch(GHL_SYNC_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Signup-Secret': GHL_SYNC_SECRET },
        body: JSON.stringify(payload),
      }).catch(function () {});

      try {
        var res = await fetch(SIGNUP_API_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });

        var data = await res.json();

        if (res.ok && data.success) {
          // Track to Klaviyo only on success
          window._learnq = window._learnq || [];
          window._learnq.push([
            'identify',
            {
              $email: payload.email,
              $first_name: payload.first_name,
              $last_name: payload.last_name,
              $source: payload.utms && payload.utms.utm_source ? payload.utms.utm_source : undefined,
            },
          ]);
          // Hide form and headings, show success
          form.style.display = 'none';
          if (heading) heading.style.display = 'none';
          if (subheading) subheading.style.display = 'none';
          showAlert(
            'success',
            '<h2>Registration successful!</h2><br>' +
              'Your account has been created. Please check your email to activate your account.<br>' +
              '<small style="opacity:0.8">If you don\'t see the email, please check your Spam folder.</small>'
          );
        } else {
          showAlert('error', '⚠️ ' + (data.error || 'An error occurred. Please try again.'));
        }
      } catch (err) {
        showAlert('error', '⚠️ Cannot connect. Please check your network and try again.');
      } finally {
        setLoading(false);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
